var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HomeTile',{ref:"homeTile",attrs:{"title":_vm.currentSite.facility,"subtitle":"Informations du site","icon":"industry","route":"Site"},on:{"enableActionButtons":_vm.enableActionButtons}}),_vm._v(" "),_c('TreeStructure',{ref:"treeStructure",on:{"enableActionButtons":_vm.enableActionButtons}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2abfbe7d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Synoptic/Index.vue
// module id = 8WmT
// module chunks = 1